import React, { useState, useEffect, useRef, ChangeEvent, useCallback } from 'react';
import _ from 'lodash';
// import PageLoader from '../components/PageLoader';
import Back from '../components/backComponent';
import '../App.css';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Auth from '../core/services/auth';
import MenuItem from '../components/MenuItem';
// import { events } from '../core/lib/data';
import { Event, DataResponsetype } from '../core/lib/types';
import EventComponent from '../components/EventComponent';
import { useLocation } from 'react-router-dom';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import InfiniteScroll from 'react-infinite-scroll-component';
import PageLoader from '../components/PageLoader';



function Events() {
    const [ event, setEvent ] = useState<DataResponsetype>({ total: 0, pages: 0, page: 0, limit: 0, data: [] })
    const [ categories, setCategories ] = useState<any>({ total: 0, pages: 0, page: 0, limit: 0, data: [] })
    
    const { state } = useLocation();
    const { name } = state || {};
    console.log(name)
    const vendor = Auth.getVendor().find((e: { name: any; })=>e.name === name)
    const [ loading, setLoading ] = useState(false);
    const inputLogoRef = useRef<HTMLInputElement>(null)
    const [ type, setType ] = useState("")
  
    const [ eventId, setEventId ] = useState('')
    const [ title, setTitle ] = useState('')
    const [ open, setOpen ] = useState(false)
    const [openDelete, setOpenDelete ] = useState(false)
    const [ description, setDescription ] = useState('')
    const [ category, setCategory ] = useState('')
    const [ subcategory, setSubCategory ] = useState('')
    const [ date, setDate] = useState<any>();
    const [ image, setImage ] = useState<File | null>()

    const [ params, setParams ] = useState(name ? {
      page: 1, limit: 6, sort: "date", vendorId: vendor.id
    } : {
      page: 1, limit: 6, sort: "date"
    })
    

    function handleLogoClick (e: any) {
      // console.log(e)

      inputLogoRef.current?.click()
    }

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.files) {
          setImage(event.target.files[0])
      }
    }

    const getData = useCallback(() => {
      //
      // setType(args)
      if (type === "posts") {
        //
        // Auth.api.get("/posts", { params: params} ).then(res=>{
        //     setPost(res.data.data)
        // })

      } else if (type === "pins") {
          //
          // Auth.api.get("/pins", { params: params}).then(res=>{
          //     setPost(res.data.data)
          // })
      } else {
          Auth.api.get("/events", { params: params} ).then(res=>{
            setEvent(res.data.data)
          })
      }

    }, [params, type ])

    useEffect(() => {

      Auth.api.get("/categories").then(res=>{
          //
          // console.log(res.data.data)
    
          //
          if (res.data.data) {
            setCategories(res.data.data)
          }
          // 
    
      }).catch(err=>{
  
              console.log(err)
    
              if (_.isArray(err.response.data.error)) {
                let error = err.response.data.error
                //
                for (let index = 0; index < error.length; index++) {
                  const err = error[index];
                  toast.error(err.message, {
                    position: "top-center",
                  });
                }
              } else {
                toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
                  position: "top-center",
                });
              }
      
      })

      setType('')
      getData()

      // Auth.api.get("/events", { params: params }).then(res=>{
      //   //   //
      //     console.log(res.data.data)
    
      //     //
      //     if (res.data.data) {
      //       setEvent(res.data.data)
      //     }
      //     // 
    
      // }).catch(err=>{
  
      //         console.log(err)
    
      //         if (_.isArray(err.response.data.error)) {
      //           let error = err.response.data.error
      //           //
      //           for (let index = 0; index < error.length; index++) {
      //             const err = error[index];
      //             toast.error(err.message, {
      //               position: "top-center",
      //             });
      //           }
      //         } else {
      //           toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
      //             position: "top-center",
      //           });
      //         }
      
      //       })
  
    }, [getData, setEvent])

    const deleteEvent = (id: string) => {

        setOpenDelete(true);
        //
        setEventId(id)
    }

    const clearEvent = () => {

      if (eventId) {
        Auth.api.delete('/events/'+eventId).then(res => {

          // console.log(res.data)


          //  setup vendor
          // Auth.setVendor(res.data.data)
          
          // setTimeout(()=>{
          //   // navigate 
          //   navigate('/vendor')
          // }, 1800)

          toast.success(res.data.message, {
            position: "top-center",
          });

          getData()

        }).catch(err=>{

          console.log(err)

          setLoading(false)

          if (_.isArray(err.response.data.error)) {
            let error = err.response.data.error
            //
            for (let index = 0; index < error.length; index++) {
              const err = error[index];
              toast.error(err.message, {
                position: "top-center",
              });
            }
          } else {
            toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
              position: "top-center",
            });
          }

        })

        setOpenDelete(false)
      }
    }

    let _events = event.data.length > 0 ? event.data.sort((a,b)=>  new Date(a.date).getTime() - new Date(b.date).getTime()) : []

    const eventItems = _events?.map(
      (event: Event, index) => 
        <EventComponent key={index} media={event.media} title={event.title} vendor={event.vendor} description={event.description} id={event.id} date={event.date} location={event.location} categoryId={event.categoryId} category={event.category} setOpen={setOpen} form={{ setEventId: setEventId, setTitle: setTitle, setDescription: setDescription, setCategory: setCategory,
          setSubCategory: setSubCategory, setDate: setDate, setImage: setImage, categories: categories }} deleteEvent={deleteEvent} />
        
    )

    const onSet = (ars: string) => {
      //
      setParams({
          page: 1, limit: 6, sort: "-date", vendorId: vendor.id
      })
      setType(ars)
    }

    const fetchData = () => {
      //
      if (event.data.length >= event.total) {
          // setMore(false)
          return;
      }

        params.page++

      //   console.log(params)

      Auth.api.get("/events", { params: params} ).then(res=> {
        //
          setEvent({
            total: event.total, 
            pages: event.pages, 
            page: event.page, 
            limit: event.limit,
            data: event.data.concat(res.data.data.data)
          })

          console.log(event.data)
            
          console.log(params)
        })
        .catch(err=>{
    
          console.log(err)

        })
    }

    const resetEventForm = () => {
      setEventId('');
      setTitle('');
      setDescription('');
      setCategory('');
      setSubCategory('');
      setImage(null);
      setDate('');
    }

    const handleSubmit = (event: any) => {
        
        event.preventDefault();
        
        // Set Loader
        setLoading(true)

        //  set form data
        // const formData = {
        //     title: title,
        // }

        const formData = new FormData()

        formData.append('vendorId', vendor.id);
        formData.append('title', title);
        formData.append('date', date.toISOString());
        formData.append('categoryId', subcategory);
        formData.append('description', description);
        formData.append('media', image as Blob);
        
        //
        if (eventId) {

          Auth.api.patch('/events/'+eventId, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Accept': 'application/json',
              'Access-Control-Allow-Origin': '*'
            }
          }).then(res => {
            setLoading(false)
  
            // console.log(res.data)
  
  
            //  setup vendor
            // Auth.setVendor(res.data.data)
            
            // setTimeout(()=>{
            //   // navigate 
            //   navigate('/vendor')
            // }, 1800)
  
            toast.success(res.data.message, {
              position: "top-center",
            });
  
            getData()

            resetEventForm()
  
          }).catch(err=>{
    
            console.log(err)
    
            setLoading(false)
  
            if (_.isArray(err.response.data.error)) {
              let error = err.response.data.error
              //
              for (let index = 0; index < error.length; index++) {
                const err = error[index];
                toast.error(err.message, {
                  position: "top-center",
                });
              }
            } else {
              toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
                position: "top-center",
              });
            }
    
          })

        } else {
          
          Auth.api.post('/events', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Accept': 'application/json',
              'Access-Control-Allow-Origin': '*'
            }
          }).then(res => {
            setLoading(false)
  
            // console.log(res.data)
  
  
            //  setup vendor
            // Auth.setVendor(res.data.data)
            
            // setTimeout(()=>{
            //   // navigate 
            //   navigate('/vendor')
            // }, 1800)
  
            toast.success(res.data.message, {
              position: "top-center",
            });
  
            getData()
  
          }).catch(err=>{
    
            console.log(err)
    
            setLoading(false)
  
            if (_.isArray(err.response.data.error)) {
              let error = err.response.data.error
              //
              for (let index = 0; index < error.length; index++) {
                const err = error[index];
                toast.error(err.message, {
                  position: "top-center",
                });
              }
            } else {
              toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
                position: "top-center",
              });
            }
    
          })
        }
        
    
    
    }

    return (
        <div className='dark:text-white dark:bg-gray-800'>
        { loading ? <PageLoader /> : '' }
            <div className=' w-full py-5 mb-3'>
                <Back className='py-4 px-5 absolute start-0 flex' title='Home'/>
                <div className='py-3 px-5 absolute end-0 flex'>
                    {name &&
                    <button onClick={e=> { setOpen(true); resetEventForm() } } type="button" className="flex flex-row items-center justify-items-center py-1.5 px-5 bg-gray-100 mb-2 text-xs font-medium text-yellow focus:outline-none rounded-full dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">  
                      <span className='pr-0.5'>Add</span> 
                      {/* <svg className="text-yellow w-3 h-3 pt-0.5" fill="currentColor" aria-hidden="true" viewBox="0 0 24 24" data-testid="ArrowForwardIosIcon"><path d="M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"></path></svg> */}
                        
                    </button>
                    }
                </div>
              </div>
              <button className='invisible' onClick={e=>onSet('')}></button>
              <ToastContainer />
            <div className="md:h-screen mx-auto space-y-2 p-4 pt-1 mb-20">
              <InfiniteScroll
                          dataLength={event.data.length > 0 ? event.data.length : [].length }
                          hasMore={true}
                          next={fetchData}
                          loader={<p className='text-center'></p>}
                      >
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-4">
                  {eventItems}               
                </div>
              </InfiniteScroll>
            </div>
            {/* Form Modal */}
            {name &&

              <Dialog open={open} onClose={setOpen} className="relative z-40">
                <DialogBackdrop
                  transition
                  className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                  <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                    <DialogPanel
                      transition
                      className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:bg-gray-800 dark:text-white"
                    >
                      <form onSubmit={handleSubmit} style={{width: '100%'}} className="space-y-4 p-6">
                              <div className="text-dark w-15 h-15 rounded-full absolute end-0 flex z-20 p-2 mr-4">
                                  <button  type="button" onClick={e=>setOpen(false)} className="relative w-max items-center justify-items-center py-2 px-3.5 bg-yellow-800  text-xs font-medium text-white focus:outline-none rounded-full dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">  
                                    close
                                  </button>
                                </div>
                              <div className='pt-2 px-2  text-left'>
                                <p className='text-sm font-medium'> { eventId ? 'Edit ' : 'Add '} Event Details </p>
                              </div>
                              <div>
                                <input type="text" minLength={4} name="title" id="title" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" autoComplete='false' onChange={ (e) => setTitle(e.target.value) } placeholder="Title" value={title } required={true}/>
                              </div>
                              <div className='grid grid-cols-3 gap-4'>
                                <div className="relative col-span-2 ">
                                  <div className="z-20 absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                                    <svg className="w-7 h-4 text-dark dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                      <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
                                    </svg>
                                  </div>
                                  <Datetime initialValue={new Date()} value={date} onChange={setDate} className='pl-11 bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500' />
                                </div>
                                <div className=''>
                                    <div className="relative">
                                      {/* pe-3.5 */}
                                        <button type='button' onClick={handleLogoClick} className="absolute z-20 inset-y-0 end-0 flex items-center px-5">
                                            <svg className="w-6 h-6 text-dark dark:text-gray-400" focusable="false" aria-hidden="true" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3.2"></circle><path d="M9 2 7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5"></path></svg>
                                        </button>
                                        <input type="text" id="logoText" disabled={true} className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={image ? image.name : 'Photo'}/>
                                    </div>

                                    {/* {image && <p className='text-xs font-medium'>{image.name}</p>} */}
                                </div>
                              </div>
                              {/* <div className='bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'> */}
                              {/* </div> */}
                              
                              {/* <Autocomplete
                                className='bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                                apiKey='AIzaSyDIz3QGrrutmfxrRrYG7j4HAQ0By581Tgs'
                                onPlaceSelected={(value) => {
                                  console.log(value);
                                  setValue(value)
                                }}
                                defaultValue={'Ghana'}
                              /> */}
                              {/* { JSON.stringify(value)} */}
                              {/* <div className="relative z-40" >
                                <input type="text" id="logoText" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  placeholder="Accra"/>
                                  
                              </div> */}
                              <div className='grid grid-cols-2 gap-4'>
                                <div>
                                  <select id="cat" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-4 py-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" value={category} onChange={ (e) => setCategory(e.target.value) }>
                                    <option selected>Category</option>
                                    {
                                      categories.data.filter((c: { parent: null; })=>c.parent === null).map(
                                        (cat: any)=> 
                                          <option value={cat.id}>{cat.name}</option>

                                      )
                                    }
                                  </select>
                                </div>
                                <div>
                                  <select id="sub" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-4 py-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" value={subcategory} onChange={ (e) => setSubCategory(e.target.value) }>
                                    <option selected>Sub-category</option>
                                    {category &&
                                      categories.data.filter((c: { parent: { id: string; } | null; })=>c.parent !== null && c.parent.id === category).map(
                                        (sub: any)=> 
                                          <option value={sub.id}>{sub.name}</option>
                                      )
                                    }
                                  </select>
                                </div>
                              </div>
                              <div>
                                <textarea rows={4} className="block p-5 w-full text-gray-900 bg-gray-50 rounded-lg  focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" value={description} placeholder="Description" onChange={ (e) => setDescription(e.target.value) } ></textarea>
                              </div>
                              



                              {/* <div className='grid grid-cols-3 gap-4'>
                                <div>
                                    <input type="text" name="country" id="country" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setCountry(e.target.value) } placeholder="Country" value={country} required={true}/>
                                </div>
                                <div className='col-span-2'>
                                    <input type="tel" name="phone" id="phone" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setPhone(e.target.value) } placeholder="Phone" value={phone} required={true}/>
                                </div>
                              </div> */}
                              <div className='w-full'>
                                <button type="submit" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">
                                  { eventId ? 'Edit ' : 'Add '}
                                   Event</button>
                                
                              </div>
                        </form>
                        
                    </DialogPanel>
                  </div>
                </div>
              </Dialog>
            }

            {name && 
              <input ref={inputLogoRef} accept='image/*' type="file" name="image" id="image" className="invisible bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ handleFileChange } placeholder="Logo" required={true}/>
            }

            {name && 
              <Dialog open={openDelete} onClose={setOpenDelete} className="relative z-40">
                          <DialogBackdrop
                            transition
                            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                          />
              
                          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                            <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                              <DialogPanel
                                transition
                                className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:bg-gray-800 dark:text-white"
                              >
                                <div className="space-y-4 p-6 w-full">
                                        <div className='pt-2 px-2  text-left'>
                                          <p className='text-sm font-medium'> Are you sure you want to "Delete Event"?</p>
                                        </div>
                                        {/* <div>
                                          <input type="text" minLength={4} name="fullname" id="fullname" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setFullname(e.target.value) } placeholder="Firstname Lastname" value={fullname} required={true}/>
                                        </div>
                                        <div className='grid grid-cols-3 gap-4'>
                                          <div>
                                              <input type="text" name="country" id="country" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setCountry(e.target.value) } placeholder="Country" value={country} required={true}/>
                                          </div>
                                          <div className='col-span-2'>
                                              <input type="tel" name="phone" id="phone" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setPhone(e.target.value) } placeholder="Phone" value={phone} required={true}/>
                                          </div>
                                        </div> */}
                                        <div className='flex flex-col space-y-4 '>
                                          <button onClick={e=> { setOpenDelete(false);setEventId('') }} type="button" className="w-full rounded-full text-dark bg-whoite hover:bg-gray-50 border border-slate-300 focus:ring-4 border-slate-500 focus:outline-none focus:ring-primary-300 font-medium text-sm px-5 py-4 text-center dark:bg-black dark:hover:bg-gray-800 dark:focus:ring-primary-800 dark:hover:border-gray-400 dark:border-black">No, Cancel</button>
              
                                          <button onClick={e=>clearEvent()} type="button" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Yes Delete </button>
                                          
                                        </div>
                                  </div>
                                {/* <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                  <button
                                    type="button"
                                    onClick={() => setOpen(false)}
                                    className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                  >
                                    Deactivate
                                  </button>
                                  <button
                                    type="button"
                                    data-autofocus
                                    onClick={() => setOpen(false)}
                                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                  >
                                    Cancel
                                  </button>
                                </div> */}
                              </DialogPanel>
                            </div>
                          </div>
                        </Dialog>
            }
          <MenuItem />
        </div>
    )
}

export default Events